// extracted by mini-css-extract-plugin
export var card1 = "CardsGrid-module--card1--7d327";
export var card2 = "CardsGrid-module--card2--c143c";
export var card3 = "CardsGrid-module--card3--4d500";
export var card4 = "CardsGrid-module--card4--ce916";
export var card5 = "CardsGrid-module--card5--640c4";
export var card6 = "CardsGrid-module--card6--bb8a9";
export var card7 = "CardsGrid-module--card7--734ad";
export var description = "CardsGrid-module--description--9ee41";
export var fadeInAnimation = "CardsGrid-module--fadeInAnimation--e5832";
export var gridContainer = "CardsGrid-module--gridContainer--1b20a";
export var gridTemplateFor3Cards = "CardsGrid-module--gridTemplateFor3Cards--010c3";
export var gridTemplateFor4Cards = "CardsGrid-module--gridTemplateFor4Cards--8f44a";
export var gridTemplateFor5Cards = "CardsGrid-module--gridTemplateFor5Cards--709fb";
export var gridTemplateFor6Cards = "CardsGrid-module--gridTemplateFor6Cards--35215";
export var gridTemplateFor7Cards = "CardsGrid-module--gridTemplateFor7Cards--633e9";